import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type AcceptTermsMutationVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
  actiontypeId: Types.Scalars['smallint']['input'];
  ipAddress?: Types.InputMaybe<Types.Scalars['String']['input']>;
  metadata?: Types.InputMaybe<Types.Scalars['jsonb']['input']>;
  createdBy: Types.Scalars['String']['input'];
  eventTime: Types.Scalars['timestamptz']['input'];
}>;


export type AcceptTermsMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: number, accepted_terms: boolean } | null, insert_usereventlogs_one?: { __typename?: 'usereventlogs', id: number, event_time: string } | null };


export const AcceptTermsDocument = gql`
    mutation AcceptTerms($userId: bigint!, $actiontypeId: smallint!, $ipAddress: String, $metadata: jsonb, $createdBy: String!, $eventTime: timestamptz!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {accepted_terms: true}) {
    id
    accepted_terms
  }
  insert_usereventlogs_one(
    object: {user_id: $userId, actiontype_id: $actiontypeId, ip_address: $ipAddress, metadata: $metadata, event_time: $eventTime, created_by: $createdBy}
  ) {
    id
    event_time
  }
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      actiontypeId: // value for 'actiontypeId'
 *      ipAddress: // value for 'ipAddress'
 *      metadata: // value for 'metadata'
 *      createdBy: // value for 'createdBy'
 *      eventTime: // value for 'eventTime'
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (update_users_by_pk, insert_usereventlogs_one): returns the full response object.
 * @source {@link src/features/auth/mutations/acceptTerms.mutation.gql}
 */
export async function acceptTerms(
  variables: AcceptTermsMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<AcceptTermsMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<AcceptTermsMutation>(
    AcceptTermsDocument,
    variables,
    requestOptions
  )
}